import { Dict } from "@chakra-ui/utils";
import { SIDEBAR_WIDTH_TRANSITION } from "../../../constants/transitions";

const MainPanel = {
  baseStyle: {
    float: "right",
    maxWidth: "100%",
    overflow: "auto",
    position: "relative",
    maxHeight: "100%",
    transition: SIDEBAR_WIDTH_TRANSITION,
  },
  variants: {
    main: (props: Dict) => ({
      float: "right",
    }),
    rtl: (props: Dict) => ({
      float: "left",
    }),
  },
  defaultProps: {
    variant: "main",
  },
};

export const MainPanelComponent = {
  components: {
    MainPanel,
  },
};

